import { COLOR_MAP, THEME_COLORS } from './scss-variables.constants';

// TODO use only as fallback when API returns values
export const STATUS_COLOR_MAP = {
  1: COLOR_MAP['light-blue'],
  2: COLOR_MAP.purple,
  3: COLOR_MAP.blue,
  4: THEME_COLORS.info,
};
